import styled from "styled-components";

export const Card = styled.div`
  margin: 10px 14px 12px;
  padding: 14px 14px 12px;
  background: #f4f4f4;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Title = styled.div`
  color: #1b2b3a;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.3;
  word-break: break-word;
`;

export const Status = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  color: #1b2b3a;
`;

export const Dot = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ $tone }) =>
    $tone === "ready" ? "#2f80ed" : $tone === "confirmed" ? "#27ae60" : "#f2c94c"};
`;

export const When = styled.div`
  color: #1b2b3a;
  font-size: 0.8rem;
  font-weight: 700;
  margin-bottom: 4px;
`;

export const JoinButton = styled.button`
  padding: 7px 12px;
  border-radius: 6px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #175a65; }
  &:disabled { background: #d0d0d0; cursor: not-allowed; }
`;

export const SupportButton = styled.button`
  margin-top: 4px;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1.5px solid #1b6b78;
  background: #fff;
  color: #1b6b78;
  font-size: 0.8rem;
  cursor: pointer;

  &:hover { background: #f0f6f8; }
`;
